<div class="container-fluid">
  <!-- Page Title -->
  <!-- <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between" style="background-color: #B71C1C; padding: 1rem; border-radius: 0.375rem; margin-bottom: 1.5rem;">
        <h4 class="mb-sm-0" style="color: white;">
          <i class="ri-file-list-3-line me-2"></i>Incident Details
        </h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0" style="background-color: transparent; padding: 0;">
            <li class="breadcrumb-item">
              <a href="javascript: void(0);" style="color: rgba(255, 255, 255, 0.8);">Incidents</a>
            </li>
            <li class="breadcrumb-item">
              <a href="/incidents" style="color: rgba(255, 255, 255, 0.8);">List</a>
            </li>
            <li class="breadcrumb-item active" style="color: white;">Details</li>
          </ol>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Incident Details -->
  <div class="row" *ngIf="incident">
    <div class="col-lg-8">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center" style="background-color: #B71C1C; color: white;">
          <h5 class="card-title mb-0" style="color: white;">
            <i class="ri-file-list-3-line me-2"></i>{{ 'INCIDENTS.INCIDENTDETAILS' | translate }}
          </h5>
          <div class="d-flex gap-2">
<!-- 
        removed this condition to enable reinforcement until the additionrequest status got completed    && (!incident.helpRequests || !incident.helpRequests.length) -->
            <button type="button" class="btn btn-sm btn-success " *ngIf="(incident.status!=='completed' && incident.crewInchargeUserId || incident.additionalRequestStatus==='completed' ) "   style="background-color: white; " (click)="handleReinforcementRequest()"  >
              <i class="ri-add-line me-1"></i>
             {{'INCIDENTS.REQUESTREINFORCEMENT' | translate }}
            </button>
          
            <button type="button" class="btn btn-sm btn-secondary" (click)="goBack()" style="background-color: white; color: #B71C1C; border-color: white;">
              <i class="ri-arrow-left-line me-1"></i> {{'INCIDENTS.BACK' | translate }}
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <strong>{{'INCIDENTS.INCIDENTNO' | translate}}:</strong> {{ incident.incidentNo || 'N/A'  }}
            </div>
            <div class="col-md-3">
              <strong>{{'INCIDENTS.TYPE' | translate }}:</strong> {{ incident.incidentType?.name || 'N/A' }}
            </div>
            <div class="col-md-3">
              <strong>{{'INCIDENTS.SEVERITY' | translate}}:</strong> 
              <span class="badge ms-1" 
                    [style.background-color]="incident.severity?.color || '#6c757d'"
                    style="color: white;">
                {{ incident.severity?.name || 'N/A' }}
              </span>
            </div>
            <div class="col-md-3">
              <strong>{{'INCIDENTS.STATUS' | translate}}:</strong> 
              <span class="badge ms-1" 
                    [class]="getStatusBadgeClass(incident.status)">
                {{ incident.status || 'N/A' }}
              </span>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <strong>{{'INCIDENTS.LOCATION' | translate}}:</strong> {{ incident.location || 'N/A' }}
            </div>
            <div class="col-md-6">
              <strong>{{'INCIDENTS.LANDMARK' | translate}}:</strong> {{ incident.landmark || 'N/A' }}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <strong>{{'INCIDENTS.CONTACTNAME' | translate}}:</strong> {{ incident.contactName || 'N/A' }}
            </div>
            <div class="col-md-6">
              <strong>{{'INCIDENTS.CONTACTNUMBER' | translate}}:</strong> {{ incident.contactNumber || 'N/A' }}
            </div>
          </div>
          <div class="row mt-2" *ngIf="incident.remarks">
            <div class="col-12">
              <strong>{{'INCIDENTS.REMARK' | translate}}:</strong> {{ incident.remarks }}
            </div>
          </div>
                   <!-- Edit Button - Bottom Right -->
          <div class="row mt-3">
            <div class="col-12 d-flex justify-content-end">
              <button type="button" class="btn btn-sm"  [disabled]="incident.status === 'cancelled' || incident.status === 'completed'"
                      (click)="openEditModal()"
                      style="background-color: #B71C1C; color: white; border-color: #B71C1C;">
                <i class="ri-edit-line me-1"></i>Edit Details
              </button>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <strong>{{'INCIDENTS.REPORTEDAT' | translate}}:</strong> {{ formatDate(incident.reportedAt) || 'N/A' }}
            </div>

            <div class="col-md-6" *ngIf="incident.status==='completed'">
              <strong>{{'INCIDENTS.COMPLETEDAT' | translate}}:</strong> {{ formatDate(incident.updatedAt) || 'N/A' }}
            </div>
           
          </div>
        </div>
      </div>


<!-- Crew Details — sirf tab dikhao jab crew assign ho -->
<div class="card mt-3" *ngIf="incident.crewInchargeUserId">
  <div class="card-header d-flex align-items-center" style="background-color: #B71C1C; color: white;">
    <h5 class="card-title mb-0" style="color: white;">
      <i class="ri-team-line me-2"></i>{{ 'INCIDENTS.CREWDETAILS' | translate }}
    </h5>
  </div>
  <div class="card-body">

    <!-- Crew Incharge -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex align-items-center gap-2">
          <i class="ri-user-star-line fs-5" style="color: #B71C1C;"></i>
          <div>
            <div class="small text-muted">{{"INCIDENTS.CREWINCHARGE" | translate}}</div>
            <strong>{{ incident.crewIncharge?.fullName || 'N/A' }}</strong>
          </div>
        </div>
      </div>
    </div>

    <!-- Crew Members -->
     <div class="small text-muted mb-2 fw-bold">
  <i class="ri-group-line me-1" style="color: #B71C1C;"></i>{{ "INCIDENTS.CREWMEMBER" | translate }}
</div>
   <div class="d-flex flex-wrap gap-2">
  <span *ngFor="let member of incident.crewMembers"
        class="badge rounded-pill"
        style="background-color: #f5f5f5; color: #333; border: 1px solid #ddd; padding: 6px 12px; font-weight: 500;">
    <i class="ri-user-line me-1"></i>{{ member.user?.fullName }}
  </span>
</div>
  </div>
</div>


    </div>

    <!-- Assign Vehicle Section -->
    <div class="col-lg-4">
      
      <!-- Assigned Vehicles Display -->
      <div class="card" *ngIf="hasAssignedVehicles || incident.status === 'completed'">
        <div class="card-header" style="background-color:  #B71C1C; color: white;">
          <h6 class="card-title mb-0" style="color: white;">
            <i class="ri-checkbox-circle-line me-2"></i>{{"INCIDENTS.ASSIGNEDVEHICLES" | translate}}
          </h6>
        </div>
        <div class="card-body">
          <!-- <div class="alert alert-success small py-2 mb-3">
            <i class="ri-checkbox-circle-line me-1"></i>
            <strong>{{ assignedVehicles.length }}</strong> vehicle(s) have been successfully assigned to this incident.
          </div> -->
          <div class="assigned-vehicles-list" style="max-height: 500px; overflow-y: auto;">
            <div *ngFor="let assignment of assignedVehicles; let i = index" 
                 class="card mb-2 border-start border-3"
                 [style.border-left-color]="assignment.vehicle.vehicleType === 'Firebrigade' ? '#B71C1C' : '#0d6efd'">
              <div class="card-body p-2">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center mb-1">
                      <i class="ri-truck-line me-1" 
                         [style.color]="assignment.vehicle.vehicleType === 'Firebrigade' ? '#B71C1C' : '#0d6efd'"></i>
                      <strong class="small">{{ assignment.vehicle.vehicleNo }}</strong>
                    </div>
                    <div class="small text-muted">
                      <div><i class="ri-fire-line me-1"></i>{{ assignment.vehicle.vehicleType }}</div>
                      <div><i class="ri-building-line me-1"></i>{{ getFireStationName(assignment.vehicle.fireStationId) }}</div>
                      <div><i class="ri-user-line me-1"></i>{{ assignment?.driver?.fullName }}</div>
                      <div *ngIf="assignment.vehicle.capacity">
                        <i class="ri-drop-line me-1"></i>{{ assignment.vehicle.capacity }}L
                      </div>
                    </div>
                    <div class="small mt-1" *ngIf="assignment.remarks" style="font-style: italic; color: #6c757d;">
                      "{{ assignment.remarks }}"
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>    
                <!-- Edit Incident Modal -->
          <ng-template #editIncidentModal let-modal>
            <div class="modal-content">
              <div class="modal-header" style="background-color: #B71C1C; color: white; border-radius: 0.375rem 0.375rem 0 0;">
                <h5 class="modal-title d-flex align-items-center" style="color: white;">
                  <i class="ri-edit-line me-2"></i>Edit Incident Details
                </h5>
                <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
              </div>
              <div class="modal-body p-4">
                <form #editIncidentForm="ngForm">
                  <div class="mb-3">
                    <label class="form-label fw-bold text-dark d-flex align-items-center">
                      <i class="ri-user-line text-primary me-2"></i>Contact Name
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="editData.contactName" name="contactName" placeholder="Enter contact name">
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-bold text-dark d-flex align-items-center">
                      <i class="ri-phone-line text-primary me-2"></i>Contact Number
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="editData.contactNumber" name="contactNumber" placeholder="Enter contact number">
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-bold text-dark d-flex align-items-center">
                      <i class="ri-map-pin-line text-primary me-2"></i>Location
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="editData.location" name="location" placeholder="Enter location address">
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-bold text-dark d-flex align-items-center">
                      <i class="ri-map-pin-user-line text-primary me-2"></i>Landmark
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="editData.landmark" name="landmark" placeholder="Enter nearest landmark">
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-bold text-dark d-flex align-items-center">
                      <i class="ri-message-2-line text-primary me-2"></i>Remarks / Incident Description
                    </label>
                    <textarea class="form-control" rows="3" [(ngModel)]="editData.remarks" name="remarks" placeholder="Enter remarks..." style="resize: vertical;"></textarea>
                  </div>
                </form>
              </div>
              <div class="modal-footer bg-light" style="border-radius: 0 0 0.375rem 0.375rem;">
                <button type="button" class="btn btn-secondary btn-lg" (click)="modal.dismiss('Cancel click')" style="min-width: 120px;">
                  <i class="ri-close-line me-1"></i>Cancel
                </button>
                <button type="button" class="btn btn-primary btn-lg" 
                        style="background-color: #B71C1C; color: white; border-color: #B71C1C; min-width: 160px;"
                        (click)="updateIncident()"
                        [disabled]="updatingIncident">
                  <span *ngIf="!updatingIncident">
                    <i class="ri-save-line me-1"></i>Save Changes
                  </span>
                  <span *ngIf="updatingIncident">
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Saving...
                  </span>
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Assignment Form (Only shown when no vehicles assigned) -->
      <div class="card" *ngIf="!hasAssignedVehicles  && incident.status !== 'completed'">
        <div class="card-header" style="background-color: #B71C1C; color: white;">
          <h6 class="card-title mb-0" style="color: white;">
            <i class="ri-truck-line me-2"></i>{{"INCIDENTS.ASSIGNVEHICLE"| translate}}
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <label class="form-label small fw-bold">{{"INCIDENTS.SELECTVEHICLES" | translate}}:</label>
              <div class="border rounded p-2" style="max-height: 200px; overflow-y: auto;">
                <div *ngFor="let vehicle of vehicles" class="form-check">
                  <input class="form-check-input" 
                         type="checkbox" 
                         [id]="'quick_vehicle_' + vehicle.id"
                         [value]="vehicle.id"
                         [checked]="isQuickVehicleSelected(vehicle.id)"
                         [disabled]="isQuickVehicleAlreadyAssigned(vehicle.id)"
                         (change)="toggleQuickVehicleSelection(vehicle.id)">
                  <label class="form-check-label" 
                         [for]="'quick_vehicle_' + vehicle.id"
                         [class.disabled]="isQuickVehicleAlreadyAssigned(vehicle.id)">
                    {{ vehicle.vehicleNo }} - {{ vehicle.vehicleType }} ({{ getFireStationName(vehicle.fireStationId) }})
                    <small *ngIf="isQuickVehicleAlreadyAssigned(vehicle.id)" 
                           class="text-danger d-block">
                      (Already assigned)
                    </small>
                  </label>
                </div>
              </div>
            </div>
          </div>
          
          <div class="row mt-3" *ngIf="selectedQuickVehicles.length > 0">
            <div class="col-12">
              <label class="form-label small fw-bold">{{"INCIDENTS.SELECTTANKERS" | translate}}:</label>
              <div class="border rounded p-2" style="max-height: 150px; overflow-y: auto;">
                <!-- Loading state -->
                <div *ngIf="loadingQuickTankers" class="text-center py-2">
                  <div class="spinner-border spinner-border-sm" role="status" style="color: #B71C1C;">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-1 text-muted mb-0 small">Loading tankers...</p>
                </div>
                
                <!-- Tanker list -->
                <div *ngIf="!loadingQuickTankers">
                  <div *ngIf="quickAvailableTankers.length > 0">
                    <div *ngFor="let tanker of quickAvailableTankers" class="form-check">
                      <input class="form-check-input" 
                             type="checkbox" 
                             [id]="'quick_tanker_' + tanker.id"
                             [value]="tanker.id"
                             [checked]="isQuickTankerSelected(tanker.id)"
                             (change)="toggleQuickTankerSelection(tanker.id)">
                      <label class="form-check-label" [for]="'quick_tanker_' + tanker.id">
                        {{ tanker.vehicleNo }} - {{ tanker.capacity }}L ({{ getFireStationName(tanker.fireStationId) }})
                      </label>
                    </div>
                  </div>
                  
                  <!-- No tankers available -->
                  <div *ngIf="quickAvailableTankers.length === 0" class="text-center py-2">
                    <p class="text-muted mb-0 small">No tankers available at selected fire station</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngIf="selectedQuickVehicles.length > 0">
            <div class="col-12">
              <label class="form-label small fw-bold">{{"INCIDENTS.REMARKS" | translate}}:</label>
              <input type="text" class="form-control" [(ngModel)]="quickAssignmentRemarks" name="quickAssignmentRemarks" placeholder="Enter remarks">
            </div>
          </div>
          
          <div class="row mt-3" *ngIf="selectedQuickVehicles.length > 0">
            <div class="col-12">
              <button type="button" 
                      class="btn btn-primary w-100" 
                      (click)="assignQuickVehiclesWithTanker()"
                      [disabled]="isQuickAssigning || selectedQuickVehicles.length === 0">
                <i class="ri-check-line me-1"></i>
                {{ isQuickAssigning ? 'INCIDENTS.ASSIGNING' : 'INCIDENTS.ASSIGNSELECTEDVEHICLES' | translate }}
              </button>
              
              <div class="small text-muted mt-2">
                <strong>{{"INCIDENTS.SELECTEDVEHICLES" | translate}} ({{ selectedQuickVehicles.length }}):</strong>
                <div *ngFor="let vehicle of selectedQuickVehicles" class="mt-1">
                  {{ vehicle.vehicleNo }} - {{ vehicle.vehicleType }}
                </div>
                
                <div *ngIf="selectedQuickTankers.length > 0" class="mt-2">
                  <strong>{{"INCIDENTS.SELECTEDTANKERS" | translate}}({{ selectedQuickTankers.length }}):</strong>
                  <div *ngFor="let tanker of selectedQuickTankers" class="mt-1">
                    {{ tanker.vehicleNo }} - {{ tanker.capacity }}L
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading State -->
          <div class="row mt-3" *ngIf="loadingQuickTankers">
            <div class="col-12">
              <div class="text-center">
                <div class="spinner-border spinner-border-sm" role="status" style="color: #B71C1C;">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span class="ms-2 small text-muted">Loading available tankers...</span>
              </div>
            </div>
          </div>

          <!-- No Tankers Available -->
          <div class="row mt-3" *ngIf="selectedQuickVehicle && !loadingQuickTankers && quickAvailableTankers.length === 0">
            <div class="col-12">
              <div class="alert alert-info small py-2">
                <i class="ri-information-line me-1"></i>
                No tankers available at {{ getFireStationName(selectedQuickVehicle.fireStationId) }}. You can assign the vehicle without a tanker.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- Help Requests Section -->
 <!-- {{incident.helpRequests}} -->
<div *ngIf="(incident?.helpRequests && incident.helpRequests.length > 0  && incident.status!=='completed') && (incident.additionalRequestStatus || incident.isCurrentUserOnScene!=='false')" class="card mt-4">
  <div class="card-header bg-warning text-dark">
    <h5 class="card-title mb-0">
      <i class="ri-alert-line me-2"></i>Pending Help Requests
    </h5>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Vehicle Type</th>
            <th>Requested Qty</th>
            <th>Source</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let helpRequest of incident.helpRequests">
            <td>{{ helpRequest.id }}</td>
            <td>
              <span *ngFor="let item of helpRequest.items; let last = last">
                {{ item.vehicleType }}{{ last ? '' : ', ' }}
              </span>
            </td>
            <td>
              <span *ngFor="let item of helpRequest.items; let last = last">
                {{ item.requestedQuantity }}{{ last ? '' : ', ' }}
              </span>
            </td>
            <td> 
              <span >{{ helpRequest.sourceOfRequest || helpRequest.requester.fullName  }}</span></td>
            <td>
              <span class="badge bg-warning text-dark">{{ helpRequest.status }}</span>
            </td>
            <td>
              <button type="button"  *ngIf=" !roleService.hasRole(['fire_station_incharge','fire_station']) "
                      class="btn btn-sm btn-primary"
                      (click)="openHelpRequestAssignment(helpRequest)"
                      [disabled]="helpRequest.status !== 'pending'">
                <i class="ri-truck-line me-1"></i>Assign Vehicles
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<div class="row mt-3" *ngIf="MediaFiles.length > 0">
    <div class="col-12">
      <div class="card">
        <!-- Header -->
        <div class="card-header" style="background-color: #B71C1C; color: white;">
          <h5 class="card-title mb-0" style="color: white;">
            <i class="ri-image-line me-2"></i>{{ 'INCIDENTS.INCIDENTMEDIA' | translate }}
          </h5>
        </div>
        
        <!-- Body: 4 Options Gallery -->
        <div class="card-body">
          <div class="row g-3">
            
            <!-- .slice(0, 4) se sirf pehle 4 media loop honge -->
            <div class="col-6 col-md-3" *ngFor="let file of MediaFiles | slice:0:4">
              
              <!-- IMAGE DISPLAY -->
              <div class="media-container position-relative rounded overflow-hidden shadow-sm" 
                   *ngIf="file.fileType === 'image'" 
                   style="height: 150px; background-color: #f8f9fa; border: 1px solid #dee2e6;">
                <img [src]="file.fileUrl" alt="Incident Image" class="img-fluid w-100 h-100" 
                     style="object-fit: cover; cursor: zoom-in;" title="Click to view"
                     (click)="openImagePopup(file.fileUrl)">
              </div>

              <!-- VIDEO DISPLAY -->
              <div class="media-container position-relative rounded overflow-hidden shadow-sm" 
                   *ngIf="file.fileType === 'video'" 
                   style="height: 150px; background-color: #000;">
                <video [src]="'https://' + file.fileUrl" class="w-100 h-100" controls style="object-fit: cover;"></video>
              </div>
              
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Map Section -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center" style="background-color: #B71C1C; color: white;">
          <h5 class="card-title mb-0" style="color: white;">
            <i class="ri-map-pin-line me-2"></i>{{'INCIDENTS.LOCATIONMAP' | translate }}
          </h5>
        </div>
        <div class="card-body p-0">
          <div id="assignment-map" style="height: 600px; width: 100%;"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Map Legend -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="background-color: #B71C1C; color: white;">
          <h6 class="card-title mb-0" style="color: white;">
            <i class="ri-compass-line me-2"></i>{{'INCIDENTS.MAPLEGENDS' | translate }}
          </h6>
        </div>
        <div class="card-body">
          <div class="row map-legend">
            <div class="col-md-4">
              <div class="legend-item">
                <img src="assets/icons/incident-marker.svg" style="width: 32px; height: 32px; margin-right: 10px;" alt="Incident">
                <span>{{'INCIDENTS.INCIDENTLOCATION' | translate}}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="legend-item">
                <img src="assets/icons/fire-station-marker.svg" style="width: 32px; height: 32px; margin-right: 10px;" alt="Fire Station">
                <span>{{'INCIDENTS.FIRESTATION' | translate}}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="legend-item">
                <img src="assets/icons/vehicle-marker.svg" style="width: 28px; height: 28px; margin-right: 10px;" alt="Vehicle">
                <span>{{'INCIDENTS.AVAILABLEVEHICLES' | translate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border" role="status" style="color: #B71C1C;">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading incident and location data...</p>
  </div>
</div>

<!-- Help Request Assignment Modal -->
<div *ngIf="selectedHelpRequest" class="modal fade show d-block" style="background-color: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          <i class="ri-truck-line me-2"></i>Assign Vehicles to Help Request #{{ selectedHelpRequest.id }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="selectedHelpRequest = null"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-info">
          <i class="ri-information-line me-2"></i>
          Select vehicles and fire stations for each requested item below.
        </div>
        
        <div *ngFor="let item of selectedHelpRequest.items" class="card mb-3">
          <div class="card-header">
            <h6 class="mb-0">
              {{ item.vehicleType }} (Requested: {{ item.requestedQuantity }})
            </h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <label class="form-label fw-bold">Select Vehicles:</label>
                <div class="border rounded p-2" style="max-height: 200px; overflow-y: auto;">
                  <!-- Loading state -->
                  <div *ngIf="loadingHelpRequestVehicles[item.id]" class="text-center py-3">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="visually-hidden">Loading vehicles...</span>
                    </div>
                    <p class="mt-2 text-muted mb-0">Loading {{ item.vehicleType }} vehicles...</p>
                  </div>
                  
                  <!-- Vehicle list -->
                  <div *ngIf="!loadingHelpRequestVehicles[item.id]">
                    <div *ngIf="helpRequestVehicles[item.id] && helpRequestVehicles[item.id].length > 0">
                      <div *ngFor="let vehicle of helpRequestVehicles[item.id]" class="form-check">
                        <input class="form-check-input" 
                               type="checkbox" 
                               [id]="'vehicle_' + item.id + '_' + vehicle.id"
                               [value]="vehicle.id"
                               [checked]="isVehicleSelected(item.id, vehicle.id)"
                               [disabled]="isVehicleSelectionDisabled(item.id, vehicle.id)"
                               (change)="toggleVehicleSelection(item.id, vehicle.id)">
                        <label class="form-check-label" 
                               [for]="'vehicle_' + item.id + '_' + vehicle.id"
                               [class.disabled]="isVehicleSelectionDisabled(item.id, vehicle.id)">
                          {{ vehicle.vehicleNo }} - {{ vehicle.type }} ({{ getFireStationName(vehicle.fireStationId) }})
                          <small *ngIf="isVehicleSelectionDisabled(item.id, vehicle.id) && !isVehicleSelected(item.id, vehicle.id)" 
                                 class="text-muted d-block">
                            (Limit reached: {{ item.requestedQuantity }} vehicle{{ item.requestedQuantity > 1 ? 's' : '' }})
                          </small>
                        </label>
                      </div>
                    </div>
                    
                    <!-- No vehicles available -->
                    <div *ngIf="!helpRequestVehicles[item.id] || helpRequestVehicles[item.id].length === 0" class="text-center py-3">
                      <p class="text-muted mb-0">No {{ item.vehicleType }} vehicles available</p>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="selectedHelpRequest = null">
          <i class="ri-close-line me-1"></i>Cancel
        </button>
        <button type="button" 
                class="btn btn-primary" 
                (click)="assignVehiclesToHelpRequest()"
                [disabled]="assigningHelpRequest">
          <i class="ri-check-line me-1"></i>
          {{ assigningHelpRequest ? 'Assigning...' : 'Assign Vehicles' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Reinforcement Request Modal -->
<ng-template #reinforcementModal let-modal>
  <div class="modal-content">
    <div class="modal-header" style="background-color: #B71C1C; color: white; border-radius: 0.375rem 0.375rem 0 0;">
      <h5 class="modal-title d-flex align-items-center">
        <i class="ri-add-circle-line me-2"></i>Request Reinforcement
      </h5>
      <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
    </div>
    <div class="modal-body p-4">
     

      <!-- Loading state for vehicle types -->
      <div *ngIf="vehicleTypes.length === 0" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading vehicle types...</span>
        </div>
        <p class="mt-3 text-muted">Loading available vehicle types...</p>
      </div>

      <form #reinforcementForm="ngForm" *ngIf="vehicleTypes.length > 0">
        <div class="row g-2">
          <div class="col-12 col-lg-3 col-md-4" *ngFor="let vehicleType of vehicleTypes">
            <div class="card border-0 shadow-sm hover-shadow transition-all">
              <div class="card-body p-2">
                <div class="text-center mb-2">
                  <h6 class="card-title fw-bold text-dark mb-1">
                    <i class="ri-truck-line text-primary me-1"></i>
                    {{ vehicleType.label }}
                  </h6>
                </div>
                <div class="d-flex gap-1 align-items-center">
                  <button type="button" 
                          class="btn btn-sm btn-outline-secondary"
                          (click)="decrementVehicleCount(vehicleType.value)"
                          [disabled]="isDecrementDisabled(vehicleType.value)">
                    <i class="ri-subtract-line"></i>
                  </button>
                  <input type="number" 
                         class="form-control form-control-sm text-center fw-bold" 
                         [(ngModel)]="reinforcementRequest[vehicleType.value]" 
                         [name]="vehicleType.value"
                         min="0"
                         max="10"
                         (change)="validateVehicleCount(vehicleType.value)"
                         style="max-width: 50px;">
                  <button type="button" 
                          class="btn btn-sm btn-outline-primary"
                          (click)="incrementVehicleCount(vehicleType.value)"
                          [disabled]="isIncrementDisabled(vehicleType.value)">
                    <i class="ri-add-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label fw-bold text-dark d-flex align-items-center mb-2">
              <i class="ri-user-settings-line me-2 text-primary"></i>
              Request Source
            </label>
            <select class="form-select" 
                    [(ngModel)]="selectedRequestSource"
                    name="requestSource">
                    <option value="">Select request source</option>
              <option *ngFor="let source of requestSources" [value]="source.value">
                {{ source.label }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold text-dark d-flex align-items-center mb-2">
              <i class="ri-message-2-line me-2 text-primary"></i>
              Description
            </label>
            <textarea class="form-control" 
                      [(ngModel)]="reinforcementRequest['remarks']" 
                      name="remarks"
                      rows="3"
                      placeholder="Specify any special requirements or urgent needs..."
                      style="resize: vertical;"></textarea>
          </div>
        </div>

        <div class="alert alert-warning d-flex align-items-center mt-4" 
             *ngIf="getTotalRequestedVehicles() === 0"
             style="border-left: 4px solid #ffc107;">
          <i class="ri-alert-line me-2 fs-5"></i>
          <div class="flex-grow-1">
            <strong>No Vehicles Selected</strong><br>
            <small class="text-muted">Please specify at least one vehicle to request reinforcement.</small>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer bg-light" style="border-radius: 0 0 0.375rem 0.375rem;">
      <button type="button" 
              class="btn btn-secondary btn-lg" 
              (click)="modal.dismiss('Cross click')"
              style="min-width: 120px;">
        <i class="ri-close-line me-1"></i>Cancel
      </button>
      <button type="button" 
              class="btn btn-primary btn-lg" 
              (click)="submitReinforcementRequest(); modal.close('Submit click')"
              [disabled]="getTotalRequestedVehicles() === 0 || isSubmittingReinforcement || vehicleTypes.length === 0"
              style="min-width: 160px;">
        <i class="ri-send-plane-line me-1"></i>
        {{ isSubmittingReinforcement ? 'Submitting...' : 'Submit Request' }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Image Popup Overlay -->
<div class="image-popup-overlay" *ngIf="selectedImageUrl" (click)="closeImagePopup()"
     style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.85); z-index: 9999; display: flex; align-items: center; justify-content: center; cursor: pointer;">
  <button type="button" (click)="closeImagePopup()" 
          style="position: absolute; top: 20px; right: 30px; background: none; border: none; color: white; font-size: 36px; cursor: pointer; z-index: 10000;">
    <i class="ri-close-line"></i>
  </button>
  <img [src]="selectedImageUrl" alt="Incident Image" 
       (click)="$event.stopPropagation()"
       style="max-width: 90%; max-height: 90%; object-fit: contain; border-radius: 8px; box-shadow: 0 0 30px rgba(0,0,0,0.5); cursor: default;">
</div>
